import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

type WrapperProps = {
  fitContentHeight?: boolean;
};

const defaultSectionHeight = 1024;

const bkpTablet = getThemeByPath('breakpoints.tablet');

const giantSpacing = getThemeByPath('spacings.giant');

const handleSectionHeight = ({ fitContentHeight = false }: WrapperProps) =>
  fitContentHeight ? 'fit-content' : `${defaultSectionHeight}px`;

export const Wrapper = styled.section<WrapperProps>`
  display: flex;
  flex-direction: column;
  height: ${handleSectionHeight};

  @media (max-width: ${bkpTablet}px) {
    height: fit-content;
    margin-top: ${giantSpacing}px;
  }
`;
